<template>
    <div class="pl20 pr20" :class="type == 'affirm' ? ['button','affirm'] : ['button','back'] " @click="emitEvent">
        {{content}}
    </div>
</template>

<script>
    export default {
        name: "hos-button",
        props:{
            content:{
                type:String,
                default:""
            },
            type:{
                type:String,
                default:""
            }
        },
        methods:{
            emitEvent(){
                this.$emit('clickEvent');
            }
        }
    }
</script>

<style scoped>
    .button{
        font-family: PingFangSC-Regular;
        height: 36px;
        border: 1px solid #3692F9;
        border-radius: 4px;
        line-height: 36px;
        text-align: center;
        display: inline-block;
        cursor: pointer;
    }
    .affirm{
        font-size: 16px;
        color: #FFFFFF;
        background: #3692F9;
    }
    .back{
        font-size: 16px;
        color: #3692F9;
    }
</style>